// Web-Audio synthesized bark. No audio file required. Two quick bursts of a
// noisy, filtered "arf" with a bit of pitch descent.

let ctx = null;

const getCtx = () => {
  if (typeof window === "undefined") return null;
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  if (!ctx) ctx = new AC();
  if (ctx.state === "suspended") ctx.resume().catch(() => {});
  return ctx;
};

const singleBark = (audio, startAt, gain = 0.6) => {
  const dur = 0.22;

  // Noise buffer for the "arf" texture
  const bufferSize = audio.sampleRate * dur;
  const noiseBuf = audio.createBuffer(1, bufferSize, audio.sampleRate);
  const nd = noiseBuf.getChannelData(0);
  for (let i = 0; i < bufferSize; i++) nd[i] = (Math.random() * 2 - 1);
  const noise = audio.createBufferSource();
  noise.buffer = noiseBuf;

  const bp = audio.createBiquadFilter();
  bp.type = "bandpass";
  bp.frequency.setValueAtTime(700, startAt);
  bp.frequency.exponentialRampToValueAtTime(220, startAt + dur);
  bp.Q.value = 1.2;

  // Tonal oscillator to give the bark a "voice"
  const osc = audio.createOscillator();
  osc.type = "sawtooth";
  osc.frequency.setValueAtTime(360, startAt);
  osc.frequency.exponentialRampToValueAtTime(160, startAt + dur);

  const oscGain = audio.createGain();
  oscGain.gain.value = 0.5;

  const master = audio.createGain();
  master.gain.setValueAtTime(0.0001, startAt);
  master.gain.exponentialRampToValueAtTime(gain, startAt + 0.02);
  master.gain.exponentialRampToValueAtTime(0.0001, startAt + dur);

  noise.connect(bp).connect(master);
  osc.connect(oscGain).connect(master);
  master.connect(audio.destination);

  noise.start(startAt);
  noise.stop(startAt + dur);
  osc.start(startAt);
  osc.stop(startAt + dur);
};

export const playBark = () => {
  const audio = getCtx();
  if (!audio) return;
  const now = audio.currentTime;
  singleBark(audio, now + 0.0, 0.65);
  singleBark(audio, now + 0.3, 0.55);
  singleBark(audio, now + 0.55, 0.5);
};
